import React, { useEffect, useState, useCallback } from "react";
import baseUrl from "../../../../api/baseUrl";
import AppointmentCounts from "../../appointment/viewappointment/components/AppointmentCounts";
import AppointmentFilter from "../../appointment/viewappointment/components/AppointmentFilter";
import AppointmentTr from "../../appointment/viewappointment/components/AppointmentTr";
import CommonLayout from "../../../../layouts/commonLayout/CommonLayout";
import CommonNav from "../../../../layouts/commonNav/CommonNav";
import "../../appointment/viewappointment/viewappointment.scss";
import Container from "../../../../layouts/containers/Container";
import { io } from "socket.io-client";
import socketauth from "../../../../api/socket";
import TabBar from "../../../../components/tabbar/TabBar";

// Memoize the AppointmentTr component to avoid unnecessary re-renders
const MemoizedAppointmentTr = React.memo(AppointmentTr);
const socket = io(`${process.env.REACT_APP_WS}`, socketauth);
function MyAppointment() {
  const [appointment, setAppointment] = useState([]);
  const [count, setCount] = useState({
    appointments: 0,
    cancelled: 0,
    completed: 0,
    pending: 0,
    inqueue: 0,
    reschudle: 0,
  });
  const [all, setAll] = useState("all");
  const [selectedOption, setSelectedOption] = useState<string>("pending");
  // Extract API call functions for memoization and to avoid re-creation on each render
  const getAppointments = useCallback(
    (status: any, all: string) => {
      baseUrl
        .get("/appointment/findAllAppointmentDentistId", {
          headers: { status: status, day: all },
        })
        .then((response) => {
          setAppointment(response.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    [] // empty dependency array to ensure it's only created once
  );
  // useCallback to memoize the function and avoid creating a new instance on each render
  const handleOptionChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setSelectedOption(value);
      getAppointments(value, all);
    },
    [all, getAppointments]
  );

  const handleDay = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setAll(value);
      getAppointments(selectedOption, value);
    },
    [selectedOption, getAppointments]
  );

  const appointmentCount = useCallback(() => {
    baseUrl
      .get("/appointment/appointmentscountsbyId", {
        headers: { status: true },
      })
      .then((response) => {
        setCount({
          appointments: response.data?.appointments,
          cancelled: response.data?.cancelled,
          completed: response.data?.completed,
          pending: response.data?.pending,
          inqueue: response.data?.inqueue,
          reschudle: response.data?.reschudle,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // Memoize combined function to avoid unnecessary re-renders
  const appointmStatus = useCallback(() => {
    getAppointments(selectedOption, all);
    appointmentCount();
  }, [getAppointments, appointmentCount, selectedOption, all]);

  // useEffect runs only once due to empty dependency array
  useEffect(() => {
    appointmStatus();
  }, [appointmStatus]);

  return (
    <>
      <TabBar title={"My Appointments"} />
      <div className="view-appointment">
        <Container>
          <AppointmentCounts count={count} />
        </Container>
        <Container className="all-appointment">
          <AppointmentFilter
            selectedOption={selectedOption}
            all={all}
            handleOptionChange={handleOptionChange}
            handleDay={handleDay}
          />
          <table>
            <thead>
              <tr>
                <th>PATIENT NAME</th>
                <th>APPOINTMENT DATE</th>
                <th>TIME SLOT</th>
                <th>TYPE</th>
                <th>PURPOSE</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              {appointment.map((item: any, index: number) => (
                <MemoizedAppointmentTr
                  appointmStatus={appointmStatus}
                  key={index}
                  item={item}
                />
              ))}
            </tbody>
          </table>
        </Container>
      </div>
    </>
  );
}

export default React.memo(MyAppointment);
